module.exports = __webpack_public_path__ + "static/media/letter-1.4963cb2b.png";